import React from "react";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";
import colors from "theme/config/colors";
import { above } from "core-web/utils/mediaqueries";
import { textStyleToString } from "theme/config/textStyles";

const StyledUnorderedList = styled("ul")`
    background-color: ${colors.neutral_50};
    border-radius: 12px;
    color: ${colors.primaryTextDark};
    padding: 24px 16px 24px 33px;
    list-style: circle;

    ${above.tabletLg} {
        padding: 24px 24px 24px 40px;
    }

    li {
        ${textStyleToString("Myriad Pro/18-140")};
        margin-bottom: 16px;

        ${above.tabletLg} {
            ${textStyleToString("Myriad Pro/16-140")};
        }

        &:last-of-type {
            margin-bottom: 0;
        }
    }
`;

const UnorderedList = ({ children }) => <StyledUnorderedList>{children}</StyledUnorderedList>;

UnorderedList.propTypes = {
    children: PropTypes.node.isRequired,
};

export default UnorderedList;
